module.exports = __webpack_public_path__ + "img/bg4.d8dea678.png";